/**
 * Link -- Hash-based anchor component.
 *
 * Renders an `<a>` tag with `href="#/path"`. Supports all standard
 * anchor props. The `to` prop is prefixed with `#` for hash routing.
 */
import React from "react";

export interface LinkProps
  extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href"> {
  /** The hash path to navigate to (e.g. "/workspaces") */
  to?: string;
  /** Alias for `to` -- used by some legacy call sites */
  href?: string;
  children?: React.ReactNode;
}

export function Link({ to, href, children, ...rest }: LinkProps) {
  const target = to ?? href ?? "/";
  return (
    <a {...rest} href={`#${target}`}>
      {children}
    </a>
  );
}
